import { render, staticRenderFns } from "./ComponentDividedPage.vue?vue&type=template&id=7228a491&"
import script from "./ComponentDividedPage.vue?vue&type=script&lang=ts&"
export * from "./ComponentDividedPage.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentDividedPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports